"use client"

import React, {useCallback} from "react";
import {Loader} from "@/app/components/loader";
import {companyPath} from "@/app/paths";
import {useOwnCompanies} from "@/hooks/queries/use-users";
import {useRedirectHandler} from "@/hooks/use-redirect-handler";

export default function Home() {
  useOwnCompanies()
  const pathProvider = useCallback((companyId: number) => companyPath(companyId), [])
  useRedirectHandler({pathProvider})
  return <Loader/>
}
